export const UPDATE_EVENTS = 'UPDATE_EVENTS';

export const updateEvents = (events) => ({
    type: UPDATE_EVENTS,
    payload: [...events],
});
